import ErrorImage from "../../assets/error.svg";
import { useTranslations } from "../../hooks/useTranslations";
import styles from "./ErrorPage.module.css";

const ErrorPage = () => {
  const { i18n } = useTranslations();
  return (
    <div className={styles.errorPage}>
      <div className={styles.title}>{i18n.errorPage.apology}</div>
      <div className={styles.children}>
        {i18n.errorPage.unexpectedError}
        <br />
        {i18n.errorPage.contactHgv}
      </div>
      <img
        src={ErrorImage}
        className={styles.image}
        alt={i18n.errorPage.altTextError}
      />
    </div>
  );
};

export default ErrorPage;
